// Update the bonuspoint div-container on PDP
export const updatePdpBonuspoints = async () => {
  const pdpBonusContainer = document.getElementById('pdp_bonus_container');
  if (pdpBonusContainer && pdpBonusContainer.dataset.pzn) {
    try {
      const url = `rpc.php?action=productbonuspoint&case=pdp&propzn=${pdpBonusContainer.dataset.pzn}`;
      const response = await fetch(url);
      const html = await response.text();
      pdpBonusContainer.innerHTML = html;
    } catch (error) {
      console.error('Error updating PDP bonuspoints:', error);
    }
  }

  const pdpBonusAlternateSize = document.querySelectorAll('._pdp_bonus_alternatesize');
  await Promise.all(
    Array.from(pdpBonusAlternateSize).map(async (element) => {
      const pzn = element.dataset.pzn;
      const targetElement = document.getElementById(`_pdp_bonus_alternatesize_${pzn}`);

      if (targetElement) {
        try {
          const url = `rpc.php?action=productbonuspoint&propzn=${pzn}`;
          const response = await fetch(url);
          const htmlContent = await response.text();

          if (htmlContent.trim() !== '') {
            targetElement.innerHTML = htmlContent;
            targetElement.classList.add('apo-cash-badge');
          }
        } catch (error) {
          console.error(`Error updating PDP bonuspoints:`, error);
        }
      }
    }),
  );
};
